import { GetSelectedBorough } from "./Model";
import Boroughs from "./borough-data";
export const BoroughsByName = Boroughs.reduce((boroughs, borough) => {
    boroughs[borough.name] = borough;
    if (borough.synonyms && borough.synonyms.length) {
        for (const synonym of borough.synonyms) {
            boroughs[synonym] = borough;
        }
    }
    return boroughs;
}, {});
export const GetBoroughByName = (name) => {
    // tslint:disable-next-line
    return BoroughsByName[name] || BoroughsByName["Other"];
};
export const BoroughTerminology = () => {
    const borough = GetBoroughByName(GetSelectedBorough());
    if (borough.name === "NorthEastAndNorthCumbria") {
        return `What area do you work in?`;
    }
    if (borough.name === "Dudley") {
        return `Which is your nearest town?`;
    }
    let boroughTerm = "borough";
    if (borough.name === "Barnet" || borough.name === "Waltham Forest") {
        boroughTerm = "ward";
    }
    else if (borough.name === "Cumbria" || borough.name === "Suffolk") {
        boroughTerm = "district";
    }
    else if (borough.name === "Bradford District" || borough.name === "Bolton" || borough.name === "Devon") {
        boroughTerm = "area";
    }
    return `Which ${boroughTerm} do you live in?`;
};
export const GetSexualityOptions = () => {
    const borough = GetBoroughByName(GetSelectedBorough());
    if (borough.name === "Lewisham") {
        return [
            {
                label: "Heterosexual or Straight"
            },
            {
                label: "Gay or Lesbian"
            },
            {
                label: "Bisexual"
            },
            {
                label: "Other sexual orientation not listed"
            },
            {
                label: "Not sure or do not know"
            },
            {
                label: "Decline to answer"
            }
        ];
    }
    return [];
};
export const GetRegionsForCurrentBorough = () => {
    const borough = GetBoroughByName(GetSelectedBorough());
    if (borough && borough.regions) {
        return borough.regions.map(name => ({ label: name }));
    }
    return [];
};
export const GetReferralOptionsForRegion = () => {
    const region = GetBoroughByName(GetSelectedBorough());
    const options = [
        {
            label: "Search Engine (i.e. Google)"
        },
        {
            label: "Social Media (i.e. Facebook, Twitter)"
        },
        {
            label: "Health Professional (i.e. GP, Pharmacist, Nurse)"
        },
        {
            label: "Friend or Family"
        },
        {
            label: "Leaflet or Poster"
        },
        {
            label: "Link on another site"
        },
        {
            label: "Community or workplace event"
        },
        {
            label: "App"
        },
        {
            label: "Other",
        }
    ];
    // NOTE: Removed for feature that never got approved.
    // {
    //   label: "Other",
    //       editable: region.name === "West Sussex",
    //     editablePlaceholder: "Please specify"
    // }
    if (region.name === "Barnsley") {
        options.splice(5, 0, { label: "Barnsley Hospital" });
    }
    if (region.name === "West Sussex") {
        const last = options.pop();
        options.push({ label: "Radio" });
        options.push({ label: "Magazine" });
        options.push(last);
    }
    return options;
};
//# sourceMappingURL=Boroughs.js.map